import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaFacebook, FaLinkedin, FaYoutube, FaInstagram, FaTiktok, FaTwitter } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer aria-label="Site Footer" className="bg-indigo-900 text-white py-20">
            <div className="container mx-auto px-4">
                {/* Navigation Links */}
                <nav className="flex flex-col sm:flex-row justify-center gap-6 mb-12 text-center text-white text-lg font-semibold">
                    <NavLink to="/" className="hover:text-indigo-500" activeClassName="font-bold">Home</NavLink>
                    <NavLink to="/about" className="hover:text-indigo-500" activeClassName="font-bold">About</NavLink>
                    <NavLink to="/projects" className="hover:text-indigo-500" activeClassName="font-bold">Projects</NavLink>
                    <a href="mailto:info@dzikoccj.org" className="hover:text-indigo-500">Contact</a>
                    <NavLink to="/support" className="hover:text-indigo-500" activeClassName="font-bold">Support Us</NavLink>
                </nav>

                {/* Social Media Icons */}
                <div className="flex justify-center space-x-8 mb-12 text-white text-3xl">
                    <a href="https://www.facebook.com/profile.php?id=61557636222692" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                        <FaFacebook />
                    </a>
                    <a href="https://www.linkedin.com/company/100894893" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                        <FaLinkedin />
                    </a>
                    <a href="https://www.youtube.com/@DzikoCCJ" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                        <FaYoutube />
                    </a>
                    <a href="https://x.com/dziko_ccj?s=11&t=uyxMr0Uh8Yrc70I0xwZuvQ" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                        <FaTwitter />
                    </a>
                    <a href="https://www.instagram.com/_dzikoccj" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                        <FaInstagram />
                    </a>
                    <a href="https://www.tiktok.com/@dziko.ccj" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-500">
                        <FaTiktok />
                    </a>
                </div>

                {/* Contact Section */}
                <div className="text-center mb-12 text-white text-base">
                    <p>Contact us:</p>
                    <p>
                        Email: <a href="mailto:info@dzikoccj.org" className="hover:text-indigo-500 underline">info@dzikoccj.org</a>
                    </p>
                </div>

                {/* Footer Bottom */}
                <div className="text-center text-gray-300 text-sm">
                    <p>&copy; 2024 DZIKO CENTRE FOR CLIMATE JUSTICE.</p>
                    <p>All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
